module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-2700.76ebb5b2.svg";